
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3415|3669|57|8951)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
